import React, { useState, useEffect } from "react";
import axios from "axios";
import "./BlogStats.css";

const API_HOST = process.env.REACT_APP_API_URL;

const BlogStats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    const authToken = sessionStorage.getItem("authToken");
    try {
      const response = await axios.get(`${API_HOST}blogs/stats/overview`, {
        headers: { "auth-token": authToken },
      });
      setStats(response.data);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching stats:", err);
      setError("Failed to load statistics");
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="stats-loading">Loading statistics...</div>;
  }

  if (error) {
    return <div className="stats-error">{error}</div>;
  }

  if (!stats) {
    return null;
  }

  const publicPercentage = stats.total > 0 ? ((stats.publicCount / stats.total) * 100).toFixed(1) : 0;
  const privatePercentage = stats.total > 0 ? ((stats.privateCount / stats.total) * 100).toFixed(1) : 0;

  return (
    <div className="blog-stats-container">
      <h2>📊 Blog Statistics Overview</h2>
      
      <div className="stats-cards">
        <div className="stat-card total">
          <div className="stat-icon">📚</div>
          <div className="stat-content">
            <div className="stat-value">{stats.total}</div>
            <div className="stat-label">Total Blogs</div>
          </div>
        </div>

        <div className="stat-card week">
          <div className="stat-icon">📅</div>
          <div className="stat-content">
            <div className="stat-value">{stats.last7Days}</div>
            <div className="stat-label">Last 7 Days</div>
          </div>
        </div>

        <div className="stat-card month">
          <div className="stat-icon">📆</div>
          <div className="stat-content">
            <div className="stat-value">{stats.last30Days}</div>
            <div className="stat-label">Last 30 Days</div>
          </div>
        </div>

        <div className="stat-card year">
          <div className="stat-icon">📈</div>
          <div className="stat-content">
            <div className="stat-value">{stats.lastYear}</div>
            <div className="stat-label">Last Year</div>
          </div>
        </div>
      </div>

      <div className="visibility-breakdown">
        <h3>Public vs Private Distribution</h3>
        <div className="breakdown-bars">
          <div className="breakdown-item">
            <div className="breakdown-label">
              <span className="visibility-badge public">Public</span>
              <span className="breakdown-count">{stats.publicCount} ({publicPercentage}%)</span>
            </div>
            <div className="progress-bar">
              <div 
                className="progress-fill public" 
                style={{ width: `${publicPercentage}%` }}
              ></div>
            </div>
          </div>

          <div className="breakdown-item">
            <div className="breakdown-label">
              <span className="visibility-badge private">Private</span>
              <span className="breakdown-count">{stats.privateCount} ({privatePercentage}%)</span>
            </div>
            <div className="progress-bar">
              <div 
                className="progress-fill private" 
                style={{ width: `${privatePercentage}%` }}
              ></div>
            </div>
          </div>
        </div>
      </div>

      <button onClick={fetchStats} className="refresh-btn">
        🔄 Refresh Stats
      </button>
    </div>
  );
};

export default BlogStats;
